import React, { useEffect, useRef, useState } from "react";
import { Box, ButtonBase } from "@mui/material";

export interface DiagnosisSeverityOption {
  label: string;
  value: string;
  color: string;
  icon: React.ReactNode;
}

interface Props {
  value: string;
  options: DiagnosisSeverityOption[];
  onChange: (value: string) => void;
}

const DiagnosisSeverityToggle: React.FC<Props> = ({
  value,
  options,
  onChange,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [indicatorStyle, setIndicatorStyle] = useState<any>({});

  useEffect(() => {
    const buttons = containerRef.current?.querySelectorAll(".severity-btn");

    const index = options.findIndex((x) => x.value === value);

    if (buttons && buttons[index]) {
      const btn = buttons[index] as HTMLElement;

      setIndicatorStyle({
        width: btn.offsetWidth,
        height: btn.offsetHeight,
        left: btn.offsetLeft,
        top: btn.offsetTop,
        backgroundColor: options[index].bg,
      });
    }
  }, [value, options]);

  return (
    <Box
      ref={containerRef}
      sx={{
        position: "relative",
        display: "flex",
        border: "1px solid #ddd",
        borderRadius: 2,
        overflow: "hidden",
        flexWrap: { xs: "wrap", md: "nowrap" },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          transition: "all .35s ease",
          borderRadius: 0,
          zIndex: 1,
          ...indicatorStyle,
        }}
      />

      {options.map((item) => {
        const selected = value === item.value;

        return (
          <ButtonBase
            key={item.value}
            className="severity-btn"
            onClick={() => onChange(item.value)}
            sx={{
              flex: {
                xs: "0 0 50%", // 2 buttons per row on mobile
                sm: 1, // equal width on desktop
              },
              maxWidth: {
                xs: "50%",
                sm: "none",
              },
              height: 48,
              position: "relative",
              zIndex: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              fontWeight: 600,
              color: item.color,
              transition: "color .3s ease",
              borderRight: {
                md: "1px solid #ddd",
              },
              borderBottom: {
                xs: "1px solid #ddd",
                sm: "none",
              },

              "&:nth-of-type(odd)": {
                borderRight: {
                  xs: "1px solid #ddd",
                  sm: "1px solid #ddd",
                },
              },

              "&:nth-of-type(even)": {
                borderRight: {
                  xs: "none",
                  sm: "1px solid #ddd",
                },
              },

              "&:last-of-type": {
                borderRight: "none",
                borderBottom: "none",
              },
            }}
          >
            {item.label}
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default DiagnosisSeverityToggle;
